import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { type ReactNode, useId } from "react"
import GetSpace from "../../utils/space"
import style from "./ListCanRemove.module.css"
import type { IconProp } from "@fortawesome/fontawesome-svg-core"
import type { ListItem } from "../List/List"
import { ButtonIcon } from "../Button/Button"
import { faMinus } from "@fortawesome/free-solid-svg-icons"
import THEME from "../../configuration/Theme"
import { SIZE } from "../../configuration/Sizes"
import Animate, { AnimationTypes } from "../Animate/Animate"

interface ListCanRemoveProps {
  icon: IconProp
  childrin?: ReactNode
  onRemove: () => void
  data: ListItem
  color?: string
  iconColor?: string
  disableButton?: boolean
  disable?: boolean
  delay?: string
  animationTypes?: keyof typeof AnimationTypes
  animationDuration?: string
}

export const ListCanRemove: React.FC<ListCanRemoveProps> = ({
  disableButton,
  onRemove,
  childrin,
  data,
  iconColor,
  color,
  icon,
  delay = "0s",
  disable,
  animationDuration,
  animationTypes = AnimationTypes.fadeInTraslate,
}) => {
  return (
    <Animate type={animationTypes} duration={animationDuration} delay={delay}>
      <div
        key={useId()}
        className={`${style.container} rounded-2xl border border-orange-100 bg-gradient-to-br from-white via-orange-50 to-orange-100/40 p-2 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md`}
        style={{ backgroundColor: color }}
      >
        <FontAwesomeIcon color={iconColor ?? THEME.colors.iconBGSecondaryColor} size="sm" icon={icon} />

        <GetSpace left={25} />

        <div className={style.divController}>
          <a
            className={style.textCount}
            data-interaction-description-key="interactionDescriptions:components.listCanRemove.listCanRemove.link.link"
          >
            {data.title}
          </a>

          {childrin}

          {!disableButton && (
            <ButtonIcon
              sizeNumber={SIZE.buttonExpandIcon}
              bgColor={THEME.colors.buttonBGCloseColor}
              iconColor={THEME.colors.buttonFGCloseColor}
              typeButton="button"
              disabled={disable}
              icon={faMinus}
              onClick={onRemove}
              descriptionKey="interactionDescriptions:components.listCanRemove.listCanRemove.button.onRemove"
            />
          )}
        </div>
      </div>
    </Animate>
  )
}
